import { AsyncPipe } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges, inject } from '@angular/core';
import { Validators } from '@angular/forms';
import { BehaviorSubject, Observable, lastValueFrom } from 'rxjs';

import { CommonShortProvince, LocationService } from '@offconon/core-api';
import { SharedUiVirtualscrollDropdownComponent } from '@offconon/shared/ui/shared-ui-virtualscroll-dropdown';
import { CommonSelectOption } from '@offconon/shared/ui/shared-ui-virtualscroll-multiselect';
import {
  CommonDropdownAndMultiselectService,
  DropdownData,
} from '@offconon/shared/utils/services/common-dropdown-and-multiselect';

@Component({
  selector: 'offconon-state-province-dropdown',
  imports: [SharedUiVirtualscrollDropdownComponent, AsyncPipe],
  providers: [CommonDropdownAndMultiselectService],
  template: `
    <offconon-shared-ui-virtualscroll-dropdown
      [selectOptions]="(locationList$ | async) || []"
      [selectedOption]="$any(commonDropdownAndMultiselectService.selectedOptions$) | async"
      (selectedOptionOutput)="select($event)"
      (paginationAndSearchOutput)="paginationAndSearchOutput($event)" />
  `,
  styles: ``,
})
export class StateProvinceDropdownComponent implements OnInit, OnChanges {
  @Input({ required: true }) stateFormControl: any;
  @Input() countryId: number;
  @Input() selectFirst = true;
  @Input() selectedId: number;

  public commonDropdownAndMultiselectService = inject(CommonDropdownAndMultiselectService);
  public locationService = inject(LocationService);
  locationList$: Observable<CommonSelectOption[]>;

  dropdownData$ = new BehaviorSubject<
    DropdownData<{
      country_id?: number;
      name?: string;
    }>
  >({ page: 1, pageSize: 50, dataList: [] });
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['countryId']) {
      this.dropdownData$.next({
        page: 1,
        pageSize: 50,
        searchJson: {
          country_id: this.countryId,
        },
        selectedId: undefined,
        dataList: [],
      });
    }
  }
  ngOnInit(): void {
    this.initializeComponent();
  }
  private initializeComponent() {
    this.locationList$ = this.commonDropdownAndMultiselectService.fetchData<
      LocationService,
      {
        service_type?: number;
        service_id?: number;
        business_id?: number;
        name?: string;
        is_exclude?: boolean;
      }
    >({
      service: this.locationService,
      action: 'locationProvinencesList',

      dropdownData: this.dropdownData$,
      mapData: (data: CommonShortProvince[]) => {
        return data?.map((item) => {
          if (!this.stateFormControl.value && item?.id) {
            this.select(item);
          }
          return {
            name: item?.name || '-',
            id: item.id,
          };
        });
      },
      selectFirst: this.selectFirst,
    });

    this.dropdownData$.next({
      page: 1,
      pageSize: 50,
      selectedId: this.selectedId,
      searchJson: {
        country_id: this.countryId,
        name: undefined,
      },
      dataList: [],
    });
  }

  updateStateFormControl(states: CommonSelectOption[] = []) {
    const stateFormControl = this.stateFormControl;

    if (states?.length === 0) {
      stateFormControl.clearValidators();
      stateFormControl.disable();
    } else {
      stateFormControl.setValidators([Validators.required]);
      stateFormControl.enable();
    }
    stateFormControl.updateValueAndValidity();
  }

  select(event: any) {
    this.stateFormControl.patchValue(event.id);
  }

  paginationAndSearchOutput(event: any) {
    lastValueFrom(this.locationList$).then((data) => {
      this.updateStateFormControl(data);
    });
    this.commonDropdownAndMultiselectService.onDataChange(event, this.dropdownData$, {
      name: event.searchString,
      country_id: this.countryId,
    });
  }
}
